module.exports = __webpack_public_path__ + "5c0c4516c4666ccd025865b5b4f61b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/icon-hair@2x.png
// module id = 1747
// module chunks = 0